<template>
	<div class="container pb_0">
		<div class="main">
			<p class="text_t type1">{{ $t('rtr_personal-asset-jpys.text1') }}</p>
			<p class="text_n">
				{{ $t('rtr_personal-asset-jpys.text2') }}<br />
				{{ $t('rtr_personal-asset-jpys.text3') }}
			</p>
			<div class="button_area">
				<button class="button_bg_red mr_10" @click="toLogin">
					{{ $t('button.asset_send') }}
				</button>
				<button class="button_bg_black" @click="notYet">
					{{ $t('button.down') }}
				</button>
			</div>
		</div>

		<div class="bottom_area_wrap">
			<div class="bottom_area">
				<div class="bg_box">
					<div class="bg_text_area tac">
						<p class="text_t type2 mb_30 pt_100">
							{{ $t('rtr_personal-asset-jpys.text4') }}
						</p>
						<p class="text_n">
							{{ $t('rtr_personal-asset-jpys.text5') }}<br />
							{{ $t('rtr_personal-asset-jpys.text6') }}
						</p>
					</div>
					<div class="icon_box">
						<div class="box1"></div>
						<div class="box2"></div>
					</div>
				</div>

				<div class="bg_box border_r_16 mb_16">
					<div class="bg_text_area left">
						<p class="text_t fc_white">
							{{ $t('rtr_personal-asset-jpys.text7') }}<br />
							{{ $t('rtr_personal-asset-jpys.text8') }}
						</p>
					</div>
				</div>

				<div class="bg_box bg_white">
					<div class="bg_text_area right tac">
						<p class="text_t">{{ $t('rtr_personal-asset-jpys.text9') }}</p>
						<p class="text_n">
							{{ $t('rtr_personal-asset-jpys.text10') }}<br />
							{{ $t('rtr_personal-asset-jpys.text11') }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Jpys',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
